import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

function ListItems(props) {
  const location = useLocation();

  const isActive = props.link === location.pathname;

  const listItemStyles = {
    textDecoration: "none",
    marginTop: props.isLogOut ? "auto" : 4,
    padding: "8px 16px",
    color: "#333",
    fontWeight: "500",
    backgroundColor: isActive ? "#e6e8eb" : "transparent",
    borderRadius: "8px",
    margin: "2px 8px",
    position: "relative",
    borderLeft: isActive ? "4px solid #1976d2" : "4px solid transparent",
    transition: "all 0.2s ease-in-out",
    boxShadow: isActive
      ? "inset 0 0 0 1px rgba(25, 118, 210, 0.18)"
      : "inset 0 0 0 1px transparent",
    '&:hover': {
      backgroundColor: "rgba(25, 118, 210, 0.08)",
      borderLeft: "4px solid rgba(25, 118, 210, 0.6)",
      boxShadow: "inset 0 0 0 1px rgba(25, 118, 210, 0.2)",
    },
  };

  const isLogout = props.isLogOut;

  return (
    <Link to={props.link} style={{ textDecoration: "none" }}>
      <ListItemButton
        sx={listItemStyles}
        onClick={isLogout ? props.onClick : null}
      >
        <ListItemIcon style={{ 
          margin: props.mt ? "2%" : "",
          minWidth: "40px"
        }}>
          {props.icon}
        </ListItemIcon>
        <ListItemText>
          <p style={{ 
            color: isActive ? "#333" : "#666", 
            fontSize: "14px", 
            margin: 0,
            fontWeight: isActive ? "500" : "400"
          }}>
            {props.name}
          </p>
        </ListItemText>
      </ListItemButton>
    </Link>
  );
}

export default ListItems;
